module.exports = __webpack_public_path__ + "static/img/3.5276bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/3.png
// module id = OlkL
// module chunks = 0